import {Box, Stack, Typography} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Icon from "../../../../@core/components/icon";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";


const StepConfirmation = () => {
    const navigate = useNavigate()
    
    const handleFinish = () => navigate('/login')
    
    return (
        <Stack spacing={6} justifyContent={'center'}>
            <Stack justifyContent={'center'}>
                <Typography fontSize={22} fontWeight={600} textAlign={'center'}>
                    Su solicitud de registro fue exitosa
                </Typography>
                <Typography fontSize={16} fontStyle={'italic'}>
                    Por favor revise su casilla de correo y siga las instrucciones para activar su cuenta
                </Typography>
            </Stack>
            <Box sx={{justifyContent: 'center', textAlign: 'center' }}>
                <CheckCircleRoundedIcon sx={{
                    userSelect: 'none',
                    width: '1em',
                    height: '1em',
                    display: 'inline-block',
                    flexShrink: 0,
                    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    fontSize: '100px',
                    marginBottom: '16px',
                    color: '#00b2c9',
                }} />
            </Box>
            <Stack direction={'row'} alignItems={'center'} justifyContent={'center'}>
                <Button variant='contained' color='primary' onClick={handleFinish} endIcon={<Icon icon='mdi:chevron-right' fontSize={20} />}>
                    Volver al inicio
                </Button>
            </Stack>
        </Stack>
    )
}


export default StepConfirmation